module.exports = __webpack_public_path__ + "img/mapClick.2f6be62e.png";